export default "__VITE_ASSET__BuwJqe_4__"